export const CONSTANTS = {
    HALF_CARD: {
        PRIVATE_ORDER_TEXT: "Order off the radar",
        BUTTON_TEXT: "Turn on incognito order",
        HIDDEN_ORDER_TEXT: "Order history will be deleted 3 hours after delivery",
        NO_NOTIFICATION_TEXT: "Applicable only on food & Instamart",
        PRIVATE_BUTTON: "private-button",
        CLOSE: "close",
        EYE_ICON: "portal/incognito_cart/Eye-off-icon.png",
        NOTIFICATION_ICON: "portal/incognito_cart/food_icon.png",
        MAIN_IMAGE: "portal/incognito_cart/incognito-order-img.png",
    },
    TOOL_TIP: {
        SILENT_TEXT: "NEW",
        INCOGNITO_MODE_TEXT: "Order off the radar",
        HIDE_ORDER_TEXT: "Your secret's safe with us \u{1F92B}",
    },
    VERTICAL_SCROLL_BAR: {
        SCROLL_TEXTS: [
            "You're in incognito mode \u{1F609}",
            "Shh... you're in ninja mode \u{1F60E}",
            "History never forgets. But now it will \u{1F92B}",
        ],
    },
    LOTTIES: {
        ACTIVE: {
            WITH_TEXT: "portal/incognito_cart/on-with-text-v13-1.json",
            WITHOUT_TEXT: "portal/incognito_cart/on-without-text-v13-1.json",
        },
        INACTIVE: {
            WITH_TEXT: "portal/incognito_cart/off-with-text-v13-1.json",
            WITHOUT_TEXT: "portal/incognito_cart/off-without-text-v13-1.json",
        },
    },
};

export const DarkCommsRainSubColor = "rgba(38, 27, 76, 1)";
export const LightCommsRainSubColor = "rgba(238, 233, 255, 1)";
